import React from "react";

import "html5shiv/dist/html5shiv.min";
import "css-browser-selector/css_browser_selector.min";
import "../vendor/js/script";

const $ = window.$;
const jQuery = window.jQuery;

export default class VendorLoader extends React.Component {
    componentDidMount() {
        window.Shadowbox.setup('.ShadowboxVideo');


        $('.slider_img').owlCarousel({
            items: 1,
            dots: true,
            loop: true,
            autoplay: true
        });

        /* about page */
        if ($(window).width() < 961) {
            $('.logo_list').owlCarousel({
                items: 1,
                nav: true,
                loop: true,
                responsive: {
                    0: {
                        items: 2
                    },
                    767: {
                        items: 3
                    },
                    1025: {
                        items: 3
                    }
                }
            });

            $('.round_inner .mo_slider').owlCarousel({
                items: 1,
                nav: true,
                loop: true,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                smartSpeed: 500,
                /*autoHeight:true*/
            });

            $('.how_work .box_wrap .round_box').click(function () {
                var _i_ = $(this).index();
                console.log(_i_);
                $('.how_work .round_info .round_outer .round_inner').addClass('active');
                $('.round_inner .mo_slider').trigger('to.owl.carousel', _i_);
            });

            $('.middle_content .close_po').click(function () {
                $('.how_work .round_info .round_outer .round_inner').removeClass('active');
            });


        } else {
            /*animaion*/
            $.fn.visible = function (partial) {
                var $t = $(this),
                    $w = $(window),
                    viewTop = $w.scrollTop(),
                    viewBottom = viewTop + $w.height(),
                    _top = $t.offset().top,
                    _bottom = _top + $t.height(),
                    compareTop = partial === true ? _bottom : _top,
                    compareBottom = partial === true ? _top : _bottom;

                return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            };
            var win = $(window);
            var allMods = $(".how_work .round_info");

            win.on('scroll', function (event) {
                allMods.each(function (i, el) {
                    var el = $(el);
                    if (el.visible(true)) {
                        setTimeout(function () {
                            el.addClass("come-in");
                            $.each($('.how_work .box_wrap .round_box'), function (i, el) {
                                /*$(el).css({'opacity':0});*/
                                setTimeout(function () {
                                    $(el).animate({
                                        'opacity': 1.0
                                    }, 700);
                                }, 400 + (i * 400));
                            });

                        }, i * 200);
                    }
                });
            });


        }

        $('.hamburger').click(function () {
            $(this).toggleClass('active');
            $('header .mobile_menu').toggleClass('active');
        });

        /* process */
        $('.how_work .box_wrap .round_box').mouseover(function () {
            $('.how_work .box_wrap .round_box').removeClass('show');
            $(this).addClass('show');
            $('.how_work .round_inner .middle_content').removeClass('show');
            $('.' + this.id).addClass('show');
        });
    }

    render() {
        return false;
    }
}